import { Component, h, Prop, State } from '@stencil/core';
import { PageNode } from 'interfaces/PageNode';

@Component({
    tag: 'kdx-mega-nav',
    styleUrl: 'kdx-mega-nav.scss',
    shadow: false
})
export class KdxMegaNav {

    @State() isMobile: boolean = true;
    @Prop() pageNodes: string = '';
    pageNodeArray: Array<PageNode> = [];

    componentWillLoad() {
        if (this.pageNodes !== '') {
            this.pageNodeArray = JSON.parse(this.pageNodes);
        }			
    }

    componentDidRender() {
		if(!document.querySelector('body').classList.contains('editing')) {
			this.enableStickyNav();
		}
		
        this.toggleMobileNav();
    }

    createChildrenMarkup(children: Array<PageNode>) {
        let output = '';
        let isStartOfCol = true;

        children.forEach((child) => {
            if (isStartOfCol) {
                if (children.some(child => child.Break === 'true')) {
                    output += '<div class="col col-4">';
                }
                else {
                    output += '<div>';
                }
                isStartOfCol = false;
            }

            output += `<div class="app-nav__child">
                    <a href="${child.UrlName}" aria-label="${child.Title}">
                        ${child.Title}
                        <kdx-icon icon="chevron-right"></kdx-icon>
                    </a>
                </div>`;

            if (child.Nodes && child.Nodes.length) {
                output += '<div class="app-nav__third-level">';

                child.Nodes.forEach((thirdLevel) => {
                    output += `<div>
                        <a href="${thirdLevel.UrlName}" target="${thirdLevel.Target}" class="${thirdLevel.SpeedbumpLink === "True" ? "speedbump-link" : ""}" aria-label="${thirdLevel.Title}">${thirdLevel.Title}</a>
                        </div>`;
                });

                output += '</div>';
            }

            if (child.Break && child.Break == 'true') {
                output += '</div>';
                isStartOfCol = true;
            }
        });

        return output;
    }

    hasThirdLevel(children : Array<PageNode>) {
        var thirdLevels = children.filter((child) => {
            return child.Nodes && child.Nodes.length;
        });

        return thirdLevels.length > 0;
    }

    menuEntered(state) {
        if (state == 'enter') {
            if (globalThis.closeOlb) {
                globalThis.closeOlb();
            }

            document.querySelector('body').classList.add('menu-entered');
        } else {
            document.querySelector('body').classList.remove('menu-entered');
        }
    }

    enableStickyNav() {
        const header = document.querySelector('.site-header');
        
        if (!header) {
            return;
        }
		
		let isSticky = false;
		let alertShown = false;
		
		const alerts = document.querySelectorAll('kdx-alert-banner');
		
		if(alerts.length == 0) {
			//console.log('no alerts');
			document.querySelector('body').classList.add('sticky-nav');
			isSticky = true;
			window.scrollTo({top: 0, behavior: 'auto'});
			return;	
		}        
		else {			
			alerts.forEach(alert =>
			{
				//console.log(alert);
				//console.log(alert.innerHTML.indexOf('class="d-none"') < 0);
				if(alert.innerHTML.indexOf('class="d-none"') < 0) {
					alertShown = true;
				}				
			});
		}
		
		if(!alertShown) {
			console.log('all alerts hidden');
			document.querySelector('body').classList.add('sticky-nav');
			isSticky = true;
			window.scrollTo({top: 0, behavior: 'auto'});
			return;
		}

        const headerPos = header.getBoundingClientRect().top;
        
        window.addEventListener('scroll', () => {
            if (window.scrollY > headerPos && !isSticky) {
                document.querySelector('body').classList.add('sticky-nav');
                isSticky = true;
            } else if (isSticky && window.scrollY <= headerPos) {
                document.querySelector('body').classList.remove('sticky-nav');
                isSticky = false;
            }
        });
    }

    mobileNavToggle(level: string, nodeIndex: number, childIndex: number = null) {
        const levels = {
            '1': '.app-nav__node',
            '2': '.app-nav__child'
        };

        let target = null;

        if (level == '1') {
            target = document.querySelectorAll('.app-nav__node')[nodeIndex];
        } else if (level == '2') {
            target = document.querySelectorAll('.app-nav__node')[nodeIndex].querySelector('.app-nav__children-mobile').querySelectorAll('.app-nav__child')[childIndex];
        }

        if (target) {
            target.classList.add('changing');

            document.querySelectorAll(levels[level]).forEach((node: HTMLElement) => {
                if (!node.classList.contains('changing')) {
                    node.classList.remove('open');
                }
            });

            target.classList.toggle('open');
            target.classList.remove('changing');
        }
    }

    calculateMobileNavPositions() {
        const nav: HTMLElement = document.querySelector('.app-nav');
        const utils: HTMLElement = document.querySelector('.site-header__utils');
        const header: HTMLElement = document.querySelector('.site-header');

        if (!nav || !utils || !header) {
            return;
        }

        const headerHeight = header.offsetHeight;
        const utilHeight = utils.offsetHeight;

        utils.style.top = headerHeight + 'px';
        nav.style.top = (headerHeight + utilHeight) + 'px';
        nav.style.maxHeight = `calc(100vh - ${headerHeight + utilHeight}px)`;
    }

    toggleMobileNav() {
        const toggle: HTMLElement = document.querySelector('.mobile-nav-toggle');
        const utils: HTMLElement = document.querySelector('.site-header__utils');
        const nav: HTMLElement = document.querySelector('.app-nav');

        if (!toggle || !nav || !utils) {
            return;
        }

        toggle.onclick = () => {
            this.calculateMobileNavPositions();
            utils.classList[close ? 'toggle' : 'remove']('open');
            nav.classList[close ? 'toggle' : 'remove']('open');
            toggle.classList[close ? 'toggle' : 'remove']('open');
            document.querySelector('body').classList[close ? 'toggle' : 'remove']('menu-open');

            const search: any = document.querySelector('kdx-site-search');
            if (search) {
                search.closeSearch();
            }
        };

        window.addEventListener('resize', () => {
            if (document.querySelector('body').classList.contains('menu-open')) {
                this.calculateMobileNavPositions();
            }
        });
    }

    render() {
        return (
            <nav class="app-nav">
                {this.pageNodeArray.map((node, nodeIndex) => (
                    <div class="app-nav__node" onMouseEnter={() => {this.menuEntered('enter')}} onMouseLeave={() => {this.menuEntered('leave')}}>
                        <div class="app-nav__parent">
                            <a href={node.UrlName} aria-label={node.Title}>
                                <span>{ node.Title }</span>

                                {Boolean(node.Nodes && node.Nodes.length) && (
                                    <kdx-icon icon="chevron-down" class="desktop-parent-arrow"></kdx-icon>
                                )}
                            </a>

                            {Boolean(node.Nodes && node.Nodes.length) && (
                                <div class="app-nav__parent-toggle" role="button" tabIndex={0} aria-label="Toggle Navigation Item" onClick={() => {this.mobileNavToggle('1', nodeIndex)}}>
                                    <kdx-icon icon="chevron-down"></kdx-icon>
                                </div>
                            )}
                        </div>

                        {(Boolean(node.Nodes && node.Nodes.length) && this.hasThirdLevel(node.Nodes)) && (
                            <div class={`app-nav__sub mega-children ${(node.Nodes.some(child => child.Break === 'true')) ? '' : 'no-break'}`}>
                                <div class="subnav-tag">{ node.Title }</div>
                                
                                <div class="subnav-content">
                                    <div class="app-nav__children">
                                        <div class="row" innerHTML={this.createChildrenMarkup(node.Nodes)}>
                                        </div>
                                    </div>

                                    <div class="app-nav__children-mobile">
                                        {node.Nodes.map((child, childIndex) => (
                                            <div class="app-nav__child">
                                                <div class="app-nav__child-link">
                                                    <a href={child.UrlName} aria-label={child.Title}>
                                                        { child.Title }
                                                    </a>

                                                    {Boolean(child.Nodes && child.Nodes.length) && (
                                                        <div class="app-nav__parent-toggle" role="button" tabIndex={0} aria-label="Toggle Navigation Item" onClick={() => {this.mobileNavToggle('2', nodeIndex, childIndex)}}>
                                                            <kdx-icon icon="chevron-down"></kdx-icon>
                                                        </div>
                                                    )}
                                                </div>

                                            {Boolean(child.Nodes && child.Nodes.length) && (
                                                    <div class="app-nav__third-level" >
                                                        {child.Nodes.map((thirdLevel) => (
                                                            <a 
                                                                href={thirdLevel.UrlName} 
                                                                aria-label={thirdLevel.Title} 
                                                                target={thirdLevel.Target} 
                                                                class={thirdLevel.SpeedbumpLink === "True" ? "speedbump-link" : ""}
                                                            >
                                                                { thirdLevel.Title }
                                                            </a>
                                                        ))}
                                                    </div>
                                            )}
                                            </div>
                                        ))}
                                    </div>

                                    {Boolean(node.CTA) && (
                                        <kdx-mega-nav-cta CTA={node.CTA}></kdx-mega-nav-cta>
                                    )}
                                </div>
                            </div>
                        )}

                        {(Boolean(node.Nodes && node.Nodes.length) && !this.hasThirdLevel(node.Nodes)) && (
                            <div class="app-nav__sub simple-children">
                                <div class="simple-children__links">
                                    {node.Nodes.map((child) => (
                                        <a href={child.UrlName} aria-label={child.Title}>
                                            { child.Title }
                                            <kdx-icon icon="chevron-right"></kdx-icon>
                                        </a>
                                    ))}
                                </div>

                                {Boolean(node.CTA) && (
                                    <kdx-mega-nav-cta CTA={node.CTA}></kdx-mega-nav-cta>
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </nav>
        );
    }
}